import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLongArrowAltRight } from 'react-icons/fa';
import projects from '../../data/ProjectsData'; // Adjust path if needed
import DiscussForm from '../../components/DiscussForm'; // Adjust path
import '../Projects.css';
import '../Home.css';

const Flats = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Filter only "Flats" category
  const flatsProjects = projects.filter((project) => project.category === 'Flats');

  return (
    <div className="projects-main">
      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero-inner d-flex justify-content-center align-items-center">
          <div>
            <h1 className="syne-title">FLATS<span className="text-rose">.</span></h1>
            <p className="text-center">
              <Link to="/" className="text-dark text-decoration-none">Home</Link> /{' '}
              <Link to="/projects" className="text-dark text-decoration-none">Projects</Link> /{' '}
              <span className="text-rose">Flats</span>
            </p>
          </div>
        </div>
      </div>

      {/* Flats Projects List */}
      <div className="container-fluid py-4">
        <div className="container py-4">
          <div className="row">
            {flatsProjects.map((project) => (
              <div className="col-lg-4 col-md-6 my-3" key={project.id}>
                <Link to={`/projects/${project.id}`} className="text-decoration-none text-dark">
                  <div className="home-land-card h-100 shadow-sm">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="img-fluid home-land-card-img"
                    />
                    <div className="home-land-card-content p-3 text-center bg-white">
                      <h6 className="fw-bold">{project.title}</h6>
                      <p className="mb-1">{project.location}</p>
                      <div className="home-about-btn text-center text-rose">
                        <FaLongArrowAltRight /> Know More
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}

            {flatsProjects.length === 0 && (
              <div className="text-center text-muted py-5">
                <h5>No flats available at the moment.</h5>
              </div>
            )}
          </div>
        </div>
      </div>


      {/* Discuss Form */}
      <DiscussForm />
    </div>
  );
};

export default Flats;
